const typography = {
  fontFamily: `'NotoSansLao-Regular', 'Roboto'`,
};

export default typography;
